<template>
  <DialogTemplate v-bind="props" :close-click-outside="false">
    <template #header>{{ config.title }}</template>
    <p>{{ config.text }}</p>
    <template #footer>
      <ul>
        <li>
          <button type="button" class="button-cancel" @click="emit('cancel')">
            {{ config.textCancel }}
          </button>
        </li>
        <li>
          <ButtonBase
            stroke="n"
            size="small"
            theme="secondary"
            rounded
            @click="emit('confirm')"
          >
            {{ config.textOk }}
          </ButtonBase>
        </li>
      </ul>
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
interface Props {
  config: any;
  iconHeader?: string;
}
const props = defineProps({
  config: null,
  iconHeader: null
});
const emit = defineEmits(["cancel", "confirm"]);
</script>
<style lang="scss" scoped>
p {
  line-height: var(--text_lh_l);
}
ul {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  align-items: center;
}
.button-cancel {
  position: relative;
  color: var(--color_neutral_700);
  text-transform: lowercase;
  @include font('s', 400);
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 0.1rem;
    background-color: var(--color_neutral_600);
  }
}
</style>
